//=================================================
//    summary: DCP ToolBarTopUnit -- Hook
//
//    remarks: 000 Tim 2021/11/03 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//             002 Tim 2023/08/15 ClassList 改排序ID 大->小
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssToolBarTopUnit from './ToolBarTopUnit.module.scss'
import './ToolBarTopUnit.css'

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'

import {LocalStorageLibs, AAALibs, GlobalLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false

let mstrDisplayName = ""
let mintAccountRole = 0
let mblnIsTeacher = false

let marrClassList = []
// #endregion Member Variables


const COMP_NAME = "ToolBarTopUnit"

function ToolBarTopUnit(props)
{
    console.log(COMP_NAME + ".Begin: ", props);

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0);
    const [anchorEl4Class, setAnchorEl4Class] = useState(null);
    const [classIndex, setClassIndex] = useState(window.gSession.Acc.CurrentClassIndex)
    // #endregion Init State

    // #region Init Ref
    let mrefClassDropdown = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        ClearMemberVariables()
        InitMemberVariables()

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mrefCleanUp.current()
        }
    }, [])


    // #region Painted Me
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        setUpdateDataTime(new Date().getTime())
    } // end of PaintedMe

    /*===========================================
    summary: componentWillUnmount 程式離開 處理資料
    remarks: 000 Tim 2023/08/15 Create
    ===========================================*/
    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")

        mblnInitialized = false

        ClearMemberVariables()

        ExecuteWillUnmount()
    } // end of CleanUp
    // #endregion Painted Me

    // #region OnTapHandler
    /*===========================================
    summary: 登出按鈕 處理
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function LogoutOnTapHandler(event)
    {
        console.log(COMP_NAME + ".LogoutOnTapHandler")
        event.preventDefault()

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // if (!window.gSession.Acc.IsOAuthLogin)
        if (!AAALibs.LoginInfo.IsOAuthLogin)
        {
            AAALibs.NormalLogout()
        }
        else
        {
            AAALibs.OAuthNormalLogout(window.gSession.Acc.OAuthLoginProvider)
        }
    } // end of LogoutOnTapHandler

    /*===========================================
    summary: 班級資訊編輯 按鈕 處理
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ClassManagementOnTapHandler(event)
    {
        console.log(COMP_NAME + ".ClassManagementOnTapHandler")
        event.preventDefault()

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (typeof(props.CallbackRef) !== 'undefined') &&
            (props.CallbackRef !== null)
            )
        {
            let objCallbackData = {
                "Action": "ClassManagementOnTap"
            }

            props.CallbackRef(objCallbackData)
        }
    } // end of ClassManagementOnTapHandler

    /*===========================================
    summary: Assign按鈕 處理
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function AssignOnTapHandler(event)
    {
        console.log(COMP_NAME + ".AssignOnTapHandler")
        event.preventDefault()
        event.stopPropagation()

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (typeof(props.CallbackRef) !== 'undefined') &&
            (props.CallbackRef !== null)
            )
        {
            let objCallbackData = {
                "Action": "AssignOnTap"
            }

            props.CallbackRef(objCallbackData)
        }
    } // end of AssignOnTapHandler

    /*===========================================
    summary: Note按鈕 處理
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function NoteOnTapHandler(event)
    {
        console.log(COMP_NAME + ".NoteOnTapHandler")
        event.preventDefault()
        event.stopPropagation()

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (typeof(props.CallbackRef) !== 'undefined') &&
            (props.CallbackRef !== null)
            )
        {
            let objCallbackData = {
                "Action": "NoteOnTap"
            }

            props.CallbackRef(objCallbackData)
        }
    } // end of NoteOnTapHandler

    // ====== BEGIN Class下拉選單 ======
    /*===========================================
    summary: 點選 Class 選單
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ClassDropdownOnTapHandler(event, StateClassIndex)
    {
        console.log(COMP_NAME +  ".ClassDropdownOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setAnchorEl4Class(event.currentTarget)

        // 開啟 下拉選單時，滾動到 所選擇的位置      Tim20.12.11
        // 滾動位置 Index * 元件高度
        let intOffsetTop = StateClassIndex * 36
        let objMenuDom = mrefClassDropdown.current.querySelector(".MuiMenu-paper")
        objMenuDom.scroll({
            top: intOffsetTop,
            left: 0
        });
    } // end of ClassDropdownOnTapHandler

    /*===========================================
    summary: 關閉Class 下拉選單
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ClassDropdownCloseEventHandler()
    {
        console.log(COMP_NAME +  ".ClassDropdownCloseEventHandler")

        setAnchorEl4Class(null)
    } // end of ClassDropdownCloseEventHandler

    /*===========================================
    summary: 點選 Class 下拉選單 選項
    remarks: 000 Tim 2021/11/03 Create
             001 Tim 2023/08/15 ClassList 改排序ID 大->小 點選處理
    ===========================================*/
    function ClassItemOnTapHandler(StateClassIndex, ClassIndex)
    {
        console.log(COMP_NAME +  ".ClassItemOnTapHandler: ")
        console.log(COMP_NAME +  ".ClassItemOnTapHandler StateClassIndex: ", StateClassIndex)
        console.log(COMP_NAME +  ".ClassItemOnTapHandler ClassIndex: ", ClassIndex)

        if (StateClassIndex !== ClassIndex)
        {
            let intClassID = parseInt(marrClassList[ClassIndex].ClassID)
            let intClassIndex = window.gSession.Acc.Class.findIndex(ClassData => (parseInt(ClassData.ClassID) === intClassID))

            window.gSession.Acc.CurrentClassIndex = intClassIndex

            LocalStorageLibs.SetAccLSElement("CurrentClassIndex", intClassIndex)

            setClassIndex(ClassIndex)

            if (
                (typeof(props.CallbackRef) !== 'undefined') &&
                (props.CallbackRef !== null)
                )
            {
                let objCallbackData = {
                    "Action": "ClassesChange",
                    "ClassIndex": intClassIndex
                }
                props.CallbackRef(objCallbackData)
            } // end of if (props.CallbackRef !== null)
        } // end of if (StateClassIndex !== ClassIndex)

        ClassDropdownCloseEventHandler()
    } // end of ClassItemOnTapHandler
    // ====== END Class下拉選單 ======
    // #endregion OnTapHandler

    // #region Other Functions
    /*===========================================
    summary: 初始化 區域 參數
    remarks: 000 Tim 2023/08/15 Create
    ===========================================*/
    function ClearMemberVariables()
    {
        console.log(COMP_NAME + ".ClearMemberVariables: ")

        mstrDisplayName = ""
        mintAccountRole = 0
        mblnIsTeacher = false

        marrClassList = []
    } // end of ClearMemberVariables

    /*===========================================
    summary: 初始化 區域 參數
    remarks: 000 Tim 2023/08/15 Create
    ===========================================*/
    function InitMemberVariables()
    {
        console.log(COMP_NAME + ".InitMemberVariables: ")

        mstrDisplayName = window.Globals.GetDisplayName()
        mintAccountRole = window.Globals.GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)
        mblnIsTeacher = GetIsTeacher()

        console.log(COMP_NAME + ".InitMemberVariables Acc.Class: ", window.gSession.Acc.Class)
        console.log(COMP_NAME + ".InitMemberVariables Acc.CurrentClassIndex: ", window.gSession.Acc.CurrentClassIndex)

        window.gSession.Acc.Class.slice().reverse().forEach((ClassData) => {
            marrClassList.push(ClassData)
        }) // end of forEach Acc.Class

        console.log(COMP_NAME + ".InitMemberVariables marrClassList: ", marrClassList)

        let intClassID = -1
        if (
            (window.gSession.Acc.CurrentClassIndex !== -1) &&

            (typeof(window.gSession.Acc.Class) !== 'undefined') &&
            (window.gSession.Acc.Class !== null) &&
            (window.gSession.Acc.Class.length > 0) &&

            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
            (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) !== 'undefined') &&
            (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID !== null)
            )
        {
            intClassID = parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID)
            console.log(COMP_NAME + ".InitMemberVariables intClassID: ", intClassID)

            let intClassIndex = marrClassList.findIndex(ClassData => (parseInt(ClassData.ClassID) === intClassID))
            if (intClassIndex >= 0)
            {
                setClassIndex(intClassIndex)
            } // end of if (intClassIndex >= 0)
        } // end of if (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID !== null)
    } // end of InitMemberVariables

    /*===========================================
    summary: 取得 判斷帳號 是否有老師身份     
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function GetIsTeacher() 
    {
        let blnIsTeacher = false
        let intIndex = 0
        let intCount = 0

        // 判斷帳號 是否有老師身份     Tim17.07.11
        if (
            (window.gSession.Acc.Class !== null) && 
            (window.gSession.Acc.Class.length > 0)
            )
        {
            intCount = window.gSession.Acc.Class.length

            while ((!blnIsTeacher) && (intIndex < intCount))
            {
                if (parseInt(window.gSession.Acc.Class[intIndex].AccountRole) === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
                {
                    blnIsTeacher = true
                }
                intIndex++
            } // end of while
        }

        return blnIsTeacher
    } // end of GetIsTeacher

    /*===========================================
    summary: 往上一層通知 自己已經 關閉
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function ExecuteWillUnmount() 
    {
        if (
            (typeof(props.CallbackRef) !== 'undefined') &&
            (props.CallbackRef !== null)
            )
        {
            let objCallbackData = {
                "Action": "WillUnmount"
            }
            props.CallbackRef(objCallbackData)
        }
    } // end of ExecuteWillUnmount
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 班級元件 Cls
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function GetClassUnitCls(StateClassIndex, ClassIndex) 
    {
        let objCls = ""

        if (StateClassIndex === ClassIndex)
        {
            objCls = cssToolBarTopUnit.divClassSelected
        }

        return objCls
    } // end of GetClassUnitCls
    // #endregion Get ClassName

    // #region Render元件
    /*===========================================
    summary: Note Button 顯示Component
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ComponentNoteButton( {CanBeAddNote} )
    {   
        if (
            (typeof(CanBeAddNote) !== 'undefined') &&
            (CanBeAddNote !== null) &&
            (parseInt(CanBeAddNote) === 1)
            )
        {
            return( 
                <div className={cssToolBarTopUnit.btnNote} onClick={(event) => NoteOnTapHandler(event)}>
                    <div className={cssToolBarTopUnit.divIconMain}>
                        <div className={cssToolBarTopUnit.btnNoteIcon}/>
                    </div>
                    <div className={cssToolBarTopUnit.btnLearningUnitText}>
                        {window.gAppUI.LBL_Note}
                    </div>
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of ComponentNoteButton

    /*===========================================
    summary: Assign Button 顯示Component
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ComponentAssignButton( {IsTeacher, CanBeAssigned} )
    {   
        if (
            (IsTeacher) && 
            (typeof(CanBeAssigned) !== 'undefined') &&
            (CanBeAssigned !== null) &&
            (parseInt(CanBeAssigned) === 1)
            )
        {
            return( 
                <div className={cssToolBarTopUnit.btnAssign} onClick={(event) => AssignOnTapHandler(event)}>
                    <div className={cssToolBarTopUnit.divIconMain}>
                        <div className={cssToolBarTopUnit.btnAssignIcon}/>
                    </div>
                    <div className={cssToolBarTopUnit.btnLearningUnitText}>
                        {window.gAppUI.LBL_Assign}
                    </div>
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of ComponentAssignButton

    /*===========================================
    summary: ClassManagement 顯示Component
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ComponentClassManagement()
    {   
        if (
            (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER) ||
            (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
            )
        {
            return(
                <div className={cssToolBarTopUnit.divClassManagement}>
                    <div className={cssToolBarTopUnit.btnClassManagement} onClick={(event) => ClassManagementOnTapHandler(event)}>
                        <div className={cssToolBarTopUnit.btnClassManagementIcon}/>
                        <div className={cssToolBarTopUnit.btnClassManagementText}>
                            {window.gAppUI.LBL_ClassManagement}
                        </div>
                    </div>

                    <div className={cssToolBarTopUnit.btnLine}/>
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of ComponentClassManagement

    /*===========================================
    summary: 登出按鈕 顯示Component
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ComponentLogoutButton()
    {   
        return(
            <div className={cssToolBarTopUnit.btnLogout} onClick={(event) => LogoutOnTapHandler(event)}>
                <div className={cssToolBarTopUnit.btnLogoutIcon}/>
                <div className={cssToolBarTopUnit.btnLogoutText}>
                    {window.gAppUI.LBL_Logout}
                </div>
            </div>
        )
    } // end of ComponentLogoutButton
                
    /*===========================================
    summary: Title 顯示Component
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ComponentTitle({Title})
    {   
        return(
            <div className={cssToolBarTopUnit.divTitle}>
                {Title}
            </div>
        )
    } // end of ComponentTitle
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render 右邊區塊 功能按鈕 for LearningUnit
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function RenderRight4LearningUnitWrapper()
    {
        // 新版 Content 沒有 PDF    Tim20.12.17
        // Email功能 為 舊版 考卷
        // 可讓使用者將自己在Practice或Review中所撰寫、錄製的作文或語音，
        // 寄送給指定Email帳號之對象，藉此達到讓老師評分、下評語等功能。
        // 目前已經 不需要了 所以拿掉       Tim21.12.07
        return (
            <div className={cssToolBarTopUnit.divRightMain}>
                <ComponentAssignButton IsTeacher={mblnIsTeacher} CanBeAssigned={props.LearningUnitDef.CanBeAssigned}/>
                <ComponentNoteButton CanBeAddNote={props.LearningUnitDef.CanBeAddNote}/>
            </div>
        )
    } // end of RenderRight4LearningUnitWrapper

    /*===========================================
    summary: Render 右邊區塊 功能按鈕 for Home & Lesson
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function RenderRight4HomeLessonWrapper()
    {
        return (
            <div className={cssToolBarTopUnit.divRightMain}>
                <ComponentClassManagement/>
                
                <ComponentLogoutButton />
            </div>
        )
    } // end of RenderRight4HomeLessonWrapper

    /*===========================================
    summary: Render 右邊區塊 功能按鈕
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function RenderRightWrapper(ButtonType)
    {
        let objBlock = ""
        if (
            (ButtonType === window.gButtonTypeEnum.Home) ||
            (ButtonType === window.gButtonTypeEnum.Lessons)
            )
        {
            objBlock = RenderRight4HomeLessonWrapper()
        }
        else if (ButtonType === window.gButtonTypeEnum.LearningUnit)
        {
            objBlock = RenderRight4LearningUnitWrapper()
        }

        return objBlock
    } // end of RenderRightWrapper

    /*===========================================
    summary: Render 左邊區塊 UserName的顯示 for 無Class
    remarks: 000 Tim 2020/11/03 Create
    ===========================================*/
    function RenderLeft4NoClassWrapper(DisplayName)
    {
        // console.log(COMP_NAME + ".RenderLeft4NoClassWrapper: ", DisplayName)

        return (
            <div className={cssToolBarTopUnit.divLeftMain}>
                <div className={cssToolBarTopUnit.divLessonsMain}>
                    <div className={cssToolBarTopUnit.divLessonsDisplayName}>
                        {DisplayName}
                    </div>
                </div>
            </div>
        )
    } // end of RenderLeft4NoClassWrapper  

    /*===========================================
    summary: Render Class 下拉 選單 選項
    remarks: 000 Tim 2021/11/03 Create
             001 Tim 2023/08/15 ClassList 改排序ID 大->小
    ===========================================*/
    function RenderClassMenuListWrapper(StateClassIndex)
    {
        return(
            <div>
                {marrClassList.map((ClassData, ClassIndex) =>
                    <MenuItem key={ClassIndex} className={GetClassUnitCls(StateClassIndex, ClassIndex)} 
                            onClick={() => ClassItemOnTapHandler(StateClassIndex, ClassIndex)}>
                        {ClassData.ClassName}
                    </MenuItem>
                )}
            </div>
        )
    } // end of RenderClassMenuListWrapper

    /*===========================================
    summary: Render 左邊區塊 UserName的顯示 for 有Class
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function RenderLeft4ClassWrapper(DisplayName, ClassName, StateClassIndex)
    {
        return (
            <div className={cssToolBarTopUnit.divLeftMain}>
                <div className={cssToolBarTopUnit.divHomeMain}>
                    <div className={cssToolBarTopUnit.divHomeDisplayName}>
                        {DisplayName}
                    </div>
                    <div className={cssToolBarTopUnit.divClass}>
                        <div className={cssToolBarTopUnit.divClassDropdown} aria-controls="menuTopToolClass" 
                                onClick={(event) => ClassDropdownOnTapHandler(event, StateClassIndex)}>
                            <div className={cssToolBarTopUnit.divClassDropdownText}>
                                {ClassName}
                            </div>
                            <div className={cssToolBarTopUnit.divClassDropdownIcon}/>
                        </div>
                        

                        <Menu id="menuTopToolClass" ref={mrefClassDropdown} anchorEl={anchorEl4Class} keepMounted 
                                open={(anchorEl4Class === null) ? false : true}
                                onClose={() => ClassDropdownCloseEventHandler()}
                                getContentAnchorEl={null}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center'
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center'
                                }}
                                className={cssToolBarTopUnit.menuTopToolClass}
                        >
                            {RenderClassMenuListWrapper(StateClassIndex)}
                        </Menu>
                    </div>
                </div>
            </div>
        )        
    } // end of RenderLeft4ClassWrapper
    
    /*===========================================
    summary: Render 左邊區塊 UserName的顯示
    remarks: 000 Tim 2021/11/03 Create
             001 Tim 2023/08/15 ClassList 改排序ID 大->小
    ===========================================*/
    function RenderLeft4HomeWrapper(DisplayName, StateClassIndex)
    {
        let objBlock = ""

        if (
            (marrClassList.length > 0) &&
            (typeof(StateClassIndex) !== 'undefined') &&
            (StateClassIndex !== null) &&
            (StateClassIndex >= 0) &&
            (typeof(marrClassList[StateClassIndex].ClassName) !== 'undefined') &&
            (marrClassList[StateClassIndex].ClassName !== null)
            )
        {
            let strClassName = marrClassList[StateClassIndex].ClassName
            objBlock = RenderLeft4ClassWrapper(DisplayName, strClassName, StateClassIndex)
        } // end of if (marrClassList[StateClassIndex].ClassName !== null)
        else
        {
            // 沒有 Class，直接用 Lessons 的顯示方式
            objBlock = RenderLeft4NoClassWrapper(DisplayName)
        } // end of else

        return objBlock 
    } // end of RenderLeft4HomeWrapper

    /*===========================================
    summary: Render 左邊區塊 UserName的顯示
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function RenderLeftWrapper(ButtonType)
    {
        console.log(COMP_NAME + ".RenderLeftWrapper ButtonType: ", ButtonType)

        let objBlock = ""

        if (ButtonType === window.gButtonTypeEnum.Home)
        {
            objBlock = RenderLeft4HomeWrapper(mstrDisplayName, classIndex)
        }
        else 
        {
            objBlock = RenderLeft4NoClassWrapper(mstrDisplayName)
        }

        return objBlock 
    } // end of RenderLeftWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <>
                {RenderLeftWrapper(props.ButtonType)}

                <ComponentTitle Title={props.Title}/>

                {RenderRightWrapper(props.ButtonType)}
            </>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function RenderMainWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssToolBarTopUnit.divMain}>
                    {RenderContentWrapper()}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper(updateDataTime)}
        </>
    )
    // #endregion Render
}
export default ToolBarTopUnit